import { Processor } from "@generator/src/flowgram/lib/processor"
import { FlowgramDisplay, GeneratorSettings, useSpec } from "@generator/src/index"
import { useEffect, useMemo, useRef, useState } from "react"

type Props = {
  settings: GeneratorSettings
  onFlowgram?: (flowgram: any) => void
  disableMouseInteraction?: boolean
}

export function DrawingGenerator(props: Props) {
  const settings = props.settings
  const container = useRef<HTMLDivElement>(null!)

  const warp = useRef(0.01)
  const nextSwap = useRef(0)

  const spec = useSpec(settings)
  spec.warp = warp.current

  const [_render, setRender] = useState(0)

  const [interactionEnabled, setInteractionEnabled] = useState(false)

  const processor = useMemo(() => {
    const layout = new Processor(spec)
    layout.generate()
    layout.finalize()
    return layout
  }, [])

  useEffect(() => {
    // Regenerate whenever spec changes
    if (processor.args !== spec) {
      processor.args = spec
      processor.generate()
      processor.finalize()
      setRender((r) => r + 1)
    }
    // Whenever shapes change, trigger a React render
    return processor.onChange(() => {
      setRender((r) => r + 1)
    })
  }, [JSON.stringify(spec)])

  const flowgram = {
    spec: processor.args,
    processor,
    shapes: processor.shapes,
    settings,
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.disableMouseInteraction) return
      setInteractionEnabled(true)
    }, 1000)

    props.onFlowgram?.(flowgram)

    return () => clearTimeout(timer)
  }, [])

  // useEffect(() => {
  //   let timer = setTimeout(() => {
  //     let counter = 0
  //     const next = () => {
  //       timer = setTimeout(() => {
  //         next()
  //         counter++
  //         if (processor.drawCells.length > 0) return
  //         warp.current += 0.005
  //         processor.args.warp = warp.current
  //         processor.generate()
  //         processor.needsUpdate = true
  //       }, 3000)
  //     }
  //     next()
  //   }, 1000)
  //   return () => clearTimeout(timer)
  // }, [settings.rows, settings.cols])

  return (
    <div
      className="relative w-full [&_canvas]:!border-0"
      ref={container}
      style={{ aspectRatio: flowgram.processor.cols + " / " + flowgram.processor.rows }}
      onMouseEnter={() => {
        if (!interactionEnabled) return
        warp.current += 0.1
        processor.args.warp = warp.current
        processor.generate()
        processor.needsUpdate = true
      }}
      onClick={() => {
        if (!interactionEnabled) return
        warp.current += 0.1
        processor.args.warp = warp.current
        processor.generate()
        processor.needsUpdate = true
      }}
    >
      <FlowgramDisplay
        primaryDimension="width"
        renderMode="draw"
        flowgram={flowgram}
        onColorChange={(colors) => {
          document.body.style.backgroundColor = colors.bgColor
        }}
      />
    </div>
  )
}
